import axios from '@fs/zion-axios'
import { usePhoneNumber } from '@fs/zion-phone-number'
import useStateManager from './useStateManager'
import useFetchData from './useFetchData'
import { subscribeToTextMessageCampaign, subscribeToWhatsAppCampaign } from '../services/notifications'
import SmsLocations from '../components/shared/SmsLocations'

const createFetchNotification = (channel) => async () => {
  const { data } = await axios.get(`/service/messaging/preferences/preferences/optin?channel=${channel}`)
  return data
}

const fetchTextMessageNotification = createFetchNotification('sms')
const fetchWhatsAppNotification = createFetchNotification('whatsapp')

const page = 'Settings: Notifications'
const reason = 'User changes notification setting'

const postSmsOptIn = (value) =>
  subscribeToTextMessageCampaign({
    value,
    page,
    reason,
  })

const postWhatsAppOptIn = (value) =>
  subscribeToWhatsAppCampaign({
    value,
    page,
    reason,
  })

function useShowFeatures({ profileView }) {
  const { value, country } = profileView.recoveryMobile
  const { alpha2 } = usePhoneNumber(value, country)
  if (!value || !country || !alpha2) {
    return {
      showSmsFeature: false,
      showWhatsAppFeature: false,
    }
  }
  return {
    showSmsFeature: SmsLocations.supportedLocations.includes(alpha2),
    showWhatsAppFeature: false,
  }
}

export default function useSmsMarketingPilot({ profileView }) {
  const { state: smsOptInLocal, handleChangeState: handleChangeSmsOptIn } = useStateManager(postSmsOptIn)
  const { state: whatsAppOptInLocal, handleChangeState: handleChangeWhatsAppOptIn } = useStateManager(postWhatsAppOptIn)
  const { showSmsFeature, showWhatsAppFeature } = useShowFeatures({ profileView })

  const { data: whatsAppOptInRemote, loading: whatsAppOptInLoading } = useFetchData(fetchWhatsAppNotification)
  const { data: smsOptInRemote, loading: smsOptInLoading } = useFetchData(fetchTextMessageNotification)

  const whatsAppOptIn = whatsAppOptInLocal ?? whatsAppOptInRemote
  const smsOptIn = smsOptInLocal ?? smsOptInRemote

  return {
    // even if feature is disabled we have to allow opted-in user to be able to opt out
    showSms: showSmsFeature || smsOptInRemote,
    smsOptIn,
    smsOptInLoading,
    handleChangeSmsOptIn,
    // even if feature is disabled we have to allow opted-in user to be able to opt out
    showWhatsApp: showWhatsAppFeature || whatsAppOptInRemote,
    whatsAppOptIn,
    whatsAppOptInLoading,
    handleChangeWhatsAppOptIn,
  }
}
